import React from 'react';
import { connect } from 'react-redux';
import { TextField, Checkbox } from '@mui/material';
import { AUTH_LEVELS } from '../../../redux/constants/roles';

import './org-edit.css';

/* eslint-disable camelcase, jsx-a11y/label-has-associated-control */

const OrgEdit = ({ data, canEdit, onChange }) => {
  const { id, name, short_name, name_abbr, mfa_required, ingest_alerts } = data;
  const handleChange = (fieldName) => (event) =>
    onChange({ ...data, [fieldName]: event.target.value });
  const handleCheckbox = (fieldName) => (event) =>
    onChange({ ...data, [fieldName]: event.target.checked });
  return (
    <div className="org-edit" key={id}>
      <form noValidate autoComplete="off">
        <div className="line">
          <TextField label="Org id" value={id < 1 ? 'New Org' : id} disabled />
          <TextField
            label="Org name"
            defaultValue={name}
            onChange={handleChange('name')}
            disabled={!canEdit}
          />
        </div>
        <div className="line">
          <TextField
            disabled={!canEdit}
            label="Short name"
            defaultValue={short_name}
            onChange={handleChange('short_name')}
          />
        </div>
        <div className="line">
          <TextField
            disabled={!canEdit}
            label="Abbreviated name"
            defaultValue={name_abbr}
            onChange={handleChange('name_abbr')}
          />
        </div>
        <div className="line">
          <label>
            MFA required?
            <Checkbox
              disabled={!canEdit}
              checked={mfa_required}
              onChange={handleCheckbox('mfa_required')}
            />
          </label>
        </div>
        <div className="line">
          <label>
            Ingest data alerts enbled?
            <Checkbox
              disabled={!canEdit}
              checked={ingest_alerts}
              onChange={handleCheckbox('ingest_alerts')}
            />
          </label>
        </div>
      </form>
    </div>
  );
};

export default connect(
  ({
    user: { userAuthLevel },
    users: {
      editing: { data },
    },
  }) => ({ data, canEdit: userAuthLevel <= AUTH_LEVELS.ORG_ADMIN })
)(OrgEdit);
